<!-- Show a loading spinner while fetching data -->
<rappider-spin [spinning]="isLoading">
  <!-- Only attempt to render when we have the necessary data -->
  <ng-container *ngIf="!isLoading && page && componentDefinitions">

    <!-- Editor buttons -->
    <ng-container *ngIf="contentTree || layout.contentTree">
      <section class="page-renderer-toolbar-buttons">
        <button nz-button
                nz-tooltip
                [nzSize]="'small'"
                [nzTooltipTitle]="'You can change the components and layout of this page on UI Editor.'"
                [routerLink]="['/content-editor/', pageId]">
          <i class='fa-regular fa-sparkles'></i> &nbsp; Edit page
        </button>
      </section>
    </ng-container>

    <!--
      Case 1: The page has a layout.
      We render the layout's tree first, and then project the page's
      content tree into the layout's <ng-content> (outlet) area.
    -->
    <rappider-content-tree-renderer *ngIf="layout; else pageContentTreeTemplate"
                                    [viewOnly]="true"
                                    [page]="layout"
                                    [contentTree]="layout.contentTree"
                                    [componentDefinitions]="componentDefinitions"
                                    [themeData]="projectTheme"
                                    [readonly]="true"
                                    [isLayout]="true"
                                    [hasLayout]="!!layout"
                                    [wrappedWithLayout]="false"
                                    [isRulerVisible]="false"
                                    [allCommentsOnPage]="[]">
      <!-- This second renderer is for the actual page content. It gets placed inside the layout's outlet. -->
      <rappider-content-tree-renderer [viewOnly]="true"
                                      [page]="page"
                                      [contentTree]="contentTree"
                                      [componentDefinitions]="componentDefinitions"
                                      [themeData]="projectTheme"
                                      [readonly]="true"
                                      [isLayout]="false"
                                      [hasLayout]="!!layout"
                                      [wrappedWithLayout]="true"
                                      [isRulerVisible]="false"
                                      [allCommentsOnPage]="[]">
      </rappider-content-tree-renderer>
    </rappider-content-tree-renderer>

    <!--
      Case 2: The page does NOT have a layout.
      We just render the page's content tree directly.
    -->
    <ng-template #pageContentTreeTemplate>
      <rappider-content-tree-renderer [viewOnly]="true"
                                      [page]="page"
                                      [contentTree]="contentTree"
                                      [componentDefinitions]="componentDefinitions"
                                      [themeData]="projectTheme"
                                      [readonly]="true"
                                      [isLayout]="false"
                                      [hasLayout]="!!layout"
                                      [wrappedWithLayout]="false"
                                      [isRulerVisible]="false"
                                      [allCommentsOnPage]="[]">
      </rappider-content-tree-renderer>
    </ng-template>

  </ng-container>
</rappider-spin>
